import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PATH } from '@app/constants';
import { DashboardV2Component } from './dashboard-v2.component';


const routes: Routes = [
  { path: PATH.DASHBOARD_HOME_V2, component: DashboardV2Component },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardV2RoutingModule { }
